export default __webpack_public_path__ + "static/media/icon_materialhub.ed07758e.svg";